import { ApiError } from '../../errors/api-error';

export function handleApiError(response: Response) {
  throw new ApiError(response.status, response.statusText);
}
